export class Dropdown {
  constructor({ wrapperId, optionsId, selectId }) {
    this.wrapper = document.getElementById(wrapperId) || undefined;
    this.options = document.getElementById(optionsId) || undefined;
    this.select = document.getElementById(selectId) || undefined;
    this.focusedIndex = -1;
  }

  /**
   * Initialize Dropdown
   * @param {Function} callback  - a callback function
   * @returns
   */
  init(callback = () => {}) {
    if (!this.wrapper || !this.options || !this.select) {
      console.warn('Sort dropdown elements not found');
      return;
    }

    this.#bindEvents(callback);
  }

  #getOptionItems() {
    return this.options.querySelectorAll('li[role="option"]');
  }

  /**
   * Attach events on different elements in Dropdown
   * @param {Function} callback - a callback function
   */
  #bindEvents(callback = () => {}) {
    this.wrapper.addEventListener('click', this.#wrapperClickHandle.bind(this));
    this.options.addEventListener(
      'click',
      (e) => e.target && e.target.tagName === 'LI' && this.#optionsClickHandle(e, callback),
    );
    document.addEventListener('click', this.#outsideClickHandle.bind(this));
    this.wrapper.addEventListener('keydown', (e) => this.#keydownHandle(e, callback));
  }

  #keydownHandle(e, callback = () => {}) {
    const items = this.#getOptionItems();
    if (!items.length) return;

    const isOpen = !this.options.classList.contains('is-hidden');

    switch (e.key) {
      case 'ArrowDown': {
        e.preventDefault();
        if (!isOpen) {
          this.#toggleDropdown();
          this.#setFocusedOption(0);
        } else {
          this.#setFocusedOption(Math.min(this.focusedIndex + 1, items.length - 1));
        }
        break;
      }
      case 'ArrowUp': {
        e.preventDefault();
        if (isOpen) {
          this.#setFocusedOption(Math.max(this.focusedIndex - 1, 0));
        }
        break;
      }
      case 'Home': {
        e.preventDefault();
        if (isOpen) this.#setFocusedOption(0);
        break;
      }
      case 'End': {
        e.preventDefault();
        if (isOpen) this.#setFocusedOption(items.length - 1);
        break;
      }
      case 'Enter':
      case ' ': {
        e.preventDefault();
        if (isOpen && this.focusedIndex >= 0 && this.focusedIndex < items.length) {
          const syntheticEvent = { target: items[this.focusedIndex], stopPropagation: () => {} };
          this.#optionsClickHandle(syntheticEvent, callback);
        } else if (!isOpen) {
          this.#toggleDropdown();
          this.#setFocusedOption(0);
        }
        break;
      }
      case 'Escape': {
        e.preventDefault();
        if (isOpen) {
          this.#toggleDropdown();
          this.wrapper.focus();
        }
        break;
      }
    }
  }

  #setFocusedOption(index) {
    const items = this.#getOptionItems();
    if (!items.length) return;

    items.forEach((item) => item.setAttribute('tabindex', '-1'));
    this.focusedIndex = index;
    items[index].setAttribute('tabindex', '0');
    items[index].focus();
  }

  #wrapperClickHandle() {
    this.#toggleDropdown();
  }

  #optionsClickHandle(e, callback = () => {}) {
    e.stopPropagation();

    this.#toggleDropdown();
    this.#setOption(e);
    this.#updateAriaSelected(e.target);
    return callback(e);
  }

  #toggleDropdown() {
    this.options.classList.toggle('is-hidden');
    const isOpen = !this.options.classList.contains('is-hidden');
    this.wrapper.setAttribute('aria-expanded', String(isOpen));
  }

  #updateAriaSelected(selectedItem) {
    const items = this.#getOptionItems();
    items.forEach((item) => {
      item.setAttribute('aria-selected', item === selectedItem ? 'true' : 'false');
    });
  }

  /**
   * Set selected option text
   * @param {Event} e - Click event
   */
  #setOption(e) {
    this.select.textContent = e.target.textContent;
  }

  /**
   * Mainly, it's charge to close dropdown menu
   * @param {Event} e - Click event
   */
  #outsideClickHandle(e) {
    e.stopPropagation();

    if (!this.wrapper.contains(e.target) && !this.options.classList.contains('is-hidden')) {
      this.#toggleDropdown();
    }
  }
}
